import React from 'react'
import { connect } from 'react-redux'
import TicketBlock from '../parts/ticket-block'
import { routes } from '../../../../constants/routes'
import DisplayValue from '../../../utils/display-value'

const mapStateToProps = (state, ownProps) => {
    return {
        menuMeta: state.ticketMenuMeta.find(tgm => tgm.ticketId === ownProps.ticket.id)
    }
}

const MenuBlock = ({ ticket, menuMeta }) => {
    return (
        <TicketBlock routeObj={routes.adminTicketMenu} config="MENUS" ticket={ticket}>
            <DisplayValue label="Notes" value={menuMeta.notes ? menuMeta.notes : <i>No notes yet...</i>} />
        </TicketBlock>
    )
}

export default connect(mapStateToProps)(MenuBlock)
